import { useState } from "react"

export default function SeccionCumpleanos({ clientes, onAsignarPuntos }) {
  const [mesActivo, setMesActivo] = useState(new Date().getMonth() + 1)
  const [busqueda, setBusqueda]   = useState("")
  const [verPasados, setVerPasados] = useState(false)

  const hoy = new Date()
  const mesNombre = ["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"]
  const mesCorto  = ["Ene","Feb","Mar","Abr","May","Jun","Jul","Ago","Sep","Oct","Nov","Dic"]

  function parsearNacimiento(str) {
    if (!str) return null
    if (typeof str === "object" && str.toDate) return str.toDate()
    const s = str.trim()
    if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(s)) {
      const [d,m,y] = s.split("/")
      return new Date(Number(y), Number(m)-1, Number(d))
    }
    if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
      const [y,m,d] = s.split("-")
      return new Date(Number(y), Number(m)-1, Number(d))
    }
    if (/^\d{1,2}\/\d{1,2}\/\d{2}$/.test(s)) {
      const [d,m,y] = s.split("/")
      return new Date(2000+Number(y), Number(m)-1, Number(d))
    }
    return null
  }

  function calcularEdad(fecha) {
    if (!fecha) return null
    let edad = hoy.getFullYear() - fecha.getFullYear()
    if (hoy.getMonth() < fecha.getMonth() || (hoy.getMonth() === fecha.getMonth() && hoy.getDate() < fecha.getDate())) edad--
    return edad
  }

  function diasParaCumple(fecha) {
    if (!fecha) return null
    const hoyNorm = new Date()
    hoyNorm.setHours(0,0,0,0)
    const cumpleEsteAnio = new Date(hoyNorm.getFullYear(), fecha.getMonth(), fecha.getDate())
    cumpleEsteAnio.setHours(0,0,0,0)
    const diff = Math.ceil((cumpleEsteAnio - hoyNorm) / (1000*60*60*24))
    return diff // negativo = ya pasó, 0 = hoy, positivo = falta
  }

  const clientesConFecha = clientes.filter(c => parsearNacimiento(c.nacimiento))

  const contarPorMes = (mes) => clientesConFecha.filter(c => parsearNacimiento(c.nacimiento).getMonth() + 1 === mes).length

  const delMes = clientesConFecha
    .filter(c => parsearNacimiento(c.nacimiento).getMonth() + 1 === mesActivo)
    .filter(c => `${c.nombre} ${c.apellido}`.toLowerCase().includes(busqueda.toLowerCase()))

  // 4 grupos
  const cumpleHoy = delMes.filter(c => diasParaCumple(parsearNacimiento(c.nacimiento)) === 0)
  const proximamente = delMes
    .filter(c => diasParaCumple(parsearNacimiento(c.nacimiento)) > 0)
    .sort((a,b) => diasParaCumple(parsearNacimiento(a.nacimiento)) - diasParaCumple(parsearNacimiento(b.nacimiento)))
  const pasadoSinPuntos = delMes
    .filter(c => {
      const dias = diasParaCumple(parsearNacimiento(c.nacimiento))
      return dias < 0 && !(c.cumple_anio === new Date().getFullYear())
    })
    .sort((a,b) => diasParaCumple(parsearNacimiento(b.nacimiento)) - diasParaCumple(parsearNacimiento(a.nacimiento)))
  const pasadoConPuntos = delMes
    .filter(c => {
      const dias = diasParaCumple(parsearNacimiento(c.nacimiento))
      return dias < 0 && c.cumple_anio === new Date().getFullYear()
    })
    .sort((a,b) => diasParaCumple(parsearNacimiento(b.nacimiento)) - diasParaCumple(parsearNacimiento(a.nacimiento)))

  const proximos30 = clientesConFecha
    .map(c => ({ c, dias: diasParaCumple(parsearNacimiento(c.nacimiento)) }))
    .filter(({ dias }) => dias !== null && dias >= 0 && dias <= 30)
    .sort((a,b) => a.dias - b.dias)

  function badgeDias(fecha, badgeColorOverride) {
    const dias = diasParaCumple(fecha)
    if (dias === null) return null
    if (dias === 0) return { texto: "🎉 ¡Hoy!", color: badgeColorOverride || "#10b981", bg: "#0a2a1a" }
    if (dias > 0 && dias <= 7)  return { texto: `En ${dias} días`, color: badgeColorOverride || "#f59e0b", bg: "#1a1200" }
    if (dias > 0) return { texto: `En ${dias} días`, color: badgeColorOverride || "#6b7280", bg: "#1a1a1a" }
    return { texto: "Ya pasó", color: "#4b5563", bg: "#1a1a1a" }
  }

  function FilaCumple({ c, disabled: btnDisabled, badgeColor }) {
    const fecha = parsearNacimiento(c.nacimiento)
    const edad  = fecha ? calcularEdad(fecha) + 1 : null
    const badge = fecha ? badgeDias(fecha, badgeColor) : null
    const dia   = fecha ? fecha.getDate() : ""
    const mes   = fecha ? mesNombre[fecha.getMonth()] : ""
    const yaDioEsteAnio = c.cumple_anio === hoy.getFullYear()
    const efectivamenteDisabled = btnDisabled || yaDioEsteAnio
    return (
      <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:"12px 16px", background:"#0d1117", border:"1px solid #1f2937", borderRadius:"10px", gap:"12px", flexWrap:"wrap" }}>
        <div style={{ flex:1, minWidth:"160px" }}>
          <div style={{ fontWeight:700, color:"#e5e7eb", fontSize:"0.9rem" }}>{c.nombre} {c.apellido}</div>
          <div style={{ fontSize:"0.8rem", color:"#6b7280", marginTop:"2px" }}>
            {dia} de {mes}{edad !== null ? ` · cumple ${edad} años` : ""}
          </div>
        </div>
        {badge && (
          <div style={{ padding:"4px 10px", borderRadius:"20px", fontSize:"0.75rem", fontWeight:700, color:badge.color, background:badge.bg, border:`1px solid ${badge.color}30`, whiteSpace:"nowrap" }}>
            {badge.texto}
          </div>
        )}
        <button
          onClick={() => onAsignarPuntos(c)}
          disabled={efectivamenteDisabled}
          style={{ padding:"6px 14px", background: efectivamenteDisabled ? "#1a1a1a" : "#c9a84c20", border:"1px solid " + (efectivamenteDisabled ? "#2a2a2a" : "#c9a84c60"), borderRadius:"6px", color: efectivamenteDisabled ? "#4b5563" : "#c9a84c", fontFamily:"Inter, sans-serif", fontWeight:700, fontSize:"0.8rem", cursor: efectivamenteDisabled ? "not-allowed" : "pointer", opacity: btnDisabled && !yaDioEsteAnio ? 0.3 : 1, whiteSpace:"nowrap" }}
        >
          {yaDioEsteAnio ? "✓ Ya asignado" : "⭐ Dar 50 pts"}
        </button>
      </div>
    )
  }

  const msgCumple = (nombre) => `Hola ${nombre}! Feliz Cumpleaños!! 🎂🎉\n\nComo regalo, te damos 50 puntos para que los uses en tu próximo viaje.\n\n¡Que tengas un día increíble! 🌍✈️ sergiolowtravel.com/dashboard`

  return (
    <div>
      <div className="admin__seccion-header">
        <div>
          <div className="admin__seccion-titulo">🎂 Cumpleaños</div>
          <div className="admin__seccion-sub">
            {contarPorMes(mesActivo) === 0
              ? `Sin cumpleaños en ${mesNombre[mesActivo-1]}`
              : `${contarPorMes(mesActivo)} cliente${contarPorMes(mesActivo)!==1?"s":""} cumplen años en ${mesNombre[mesActivo-1]}`
            }
          </div>
        </div>
      </div>

      {/* Selector de mes */}
      <div style={{ display:"flex", overflowX:"auto", gap:"6px", paddingBottom:"8px", marginBottom:"16px" }}>
        {mesCorto.map((m, i) => {
          const num   = i + 1
          const cant  = contarPorMes(num)
          const activo = num === mesActivo
          const esHoy  = num === (hoy.getMonth() + 1)
          return (
            <button
              key={num}
              onClick={() => setMesActivo(num)}
              style={{
                position:"relative", flexShrink:0,
                padding:"8px 12px", minWidth:"58px",
                background: activo ? "#c9a84c15" : "#1a1a1a",
                border:"1px solid " + (activo ? "#c9a84c" : "#2a2a2a"),
                borderRadius:"8px", cursor:"pointer",
                color: activo ? "#c9a84c" : "#6b7280",
                fontFamily:"Inter, sans-serif", fontWeight:700, fontSize:"0.8rem",
                textAlign:"center"
              }}
            >
              {esHoy && <span style={{ position:"absolute", top:"4px", right:"6px", width:"5px", height:"5px", borderRadius:"50%", background:"#c9a84c", display:"block" }}/>}
              <div>{m}</div>
              {cant > 0 && <div style={{ fontSize:"0.7rem", color: activo ? "#c9a84c" : "#4b5563", marginTop:"2px" }}>{cant}</div>}
            </button>
          )
        })}
      </div>

      {/* Buscador */}
      <input
        className="admin__busqueda"
        placeholder="Buscar por nombre..."
        value={busqueda}
        onChange={e => setBusqueda(e.target.value)}
        style={{ width:"100%", maxWidth:"340px", marginBottom:"16px" }}
      />

      {/* Lista del mes — 4 grupos */}
      {delMes.length === 0 ? (
        <div className="admin__empty">
          <div className="admin__empty-icono">🎂</div>
          <div className="admin__empty-texto">Sin cumpleaños en {mesNombre[mesActivo-1]}</div>
        </div>
      ) : (
        <div style={{ display:"flex", flexDirection:"column", gap:"4px" }}>

          {/* Grupo 1 — Hoy */}
          {cumpleHoy.map(c => (
            <div key={c.id} style={{ background:"rgba(201,168,76,0.08)", border:"1px solid #c9a84c", borderRadius:"12px", padding:"16px", marginBottom:"8px" }}>
              <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", flexWrap:"wrap", gap:"12px" }}>
                <div>
                  <div style={{ fontWeight:700, color:"#c9a84c", fontSize:"0.95rem" }}>🎂 {c.nombre} {c.apellido}</div>
                  <div style={{ fontSize:"0.8rem", color:"#6b7280", marginTop:"2px" }}>Cumple {calcularEdad(parsearNacimiento(c.nacimiento)) + 1} años hoy</div>
                </div>
                <button onClick={() => onAsignarPuntos(c)} disabled={c.cumple_anio === new Date().getFullYear()} style={{ padding:"6px 14px", background: c.cumple_anio === new Date().getFullYear() ? "#1a1a1a" : "#c9a84c20", border:"1px solid " + (c.cumple_anio === new Date().getFullYear() ? "#2a2a2a" : "#c9a84c60"), borderRadius:"6px", color: c.cumple_anio === new Date().getFullYear() ? "#4b5563" : "#c9a84c", fontFamily:"Inter, sans-serif", fontWeight:700, fontSize:"0.8rem", cursor: c.cumple_anio === new Date().getFullYear() ? "default" : "pointer" }}>
                  {c.cumple_anio === new Date().getFullYear() ? "✓ Ya asignado" : "⭐ Dar 50 pts"}
                </button>
              </div>
              <textarea
                readOnly
                value={msgCumple(c.nombre)}
                style={{ width:"100%", marginTop:"12px", padding:"10px", background:"#1a1a1a", border:"1px solid #2a2a2a", borderRadius:"8px", color:"#e5e7eb", fontSize:"0.8rem", resize:"none", fontFamily:"Inter, sans-serif", lineHeight:1.5, boxSizing:"border-box" }}
                rows={3}
              />
              <button
                onClick={() => navigator.clipboard.writeText(msgCumple(c.nombre))}
                style={{ marginTop:"8px", padding:"6px 14px", background:"#25d36620", border:"1px solid #25d36660", borderRadius:"6px", color:"#25d366", fontFamily:"Inter, sans-serif", fontWeight:700, fontSize:"0.8rem", cursor:"pointer" }}
              >
                Copiar mensaje
              </button>
            </div>
          ))}

          {/* Grupo 2 — Próximamente */}
          {proximamente.length > 0 && (
            <>
              <div style={{ fontSize:"0.72rem", fontWeight:800, color:"#4b5563", textTransform:"uppercase", letterSpacing:"0.6px", margin:"16px 0 8px" }}>📅 Próximamente</div>
              {proximamente.map(c => <FilaCumple key={c.id} c={c} disabled={true} badgeColor="#3b82f6"/>)}
            </>
          )}

          {/* Grupo 3 — Pendientes de regalo */}
          {pasadoSinPuntos.length > 0 && (
            <>
              <div style={{ fontSize:"0.72rem", fontWeight:800, color:"#f59e0b", textTransform:"uppercase", letterSpacing:"0.6px", margin:"16px 0 8px" }}>⚠️ Pendientes de regalo</div>
              {pasadoSinPuntos.map(c => <FilaCumple key={c.id} c={c}/>)}
            </>
          )}

          {/* Grupo 4 — Regalo enviado */}
          {pasadoConPuntos.length > 0 && (
            <>
              <div style={{ display:"flex", alignItems:"center", gap:"12px", margin:"16px 0 8px" }}>
                <div style={{ fontSize:"0.72rem", fontWeight:800, color:"#4b5563", textTransform:"uppercase", letterSpacing:"0.6px" }}>✔️ Regalo enviado</div>
                <button onClick={() => setVerPasados(p => !p)} style={{ background:"none", border:"1px solid #2a2a2a", borderRadius:"6px", color:"#4b5563", fontSize:"0.72rem", fontWeight:700, cursor:"pointer", padding:"2px 8px" }}>
                  {verPasados ? "Ocultar" : `Ver (${pasadoConPuntos.length})`}
                </button>
              </div>
              {verPasados && pasadoConPuntos.map(c => (
                <div key={c.id} style={{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:"10px 16px", background:"#0d1117", border:"1px solid #1a1a1a", borderRadius:"10px", gap:"12px", flexWrap:"wrap", opacity:0.5 }}>
                  <div style={{ flex:1, minWidth:"160px" }}>
                    <div style={{ fontWeight:700, color:"#6b7280", fontSize:"0.9rem" }}>{c.nombre} {c.apellido}</div>
                    <div style={{ fontSize:"0.8rem", color:"#4b5563", marginTop:"2px" }}>
                      {parsearNacimiento(c.nacimiento)?.getDate()} de {mesNombre[parsearNacimiento(c.nacimiento)?.getMonth()]}
                    </div>
                  </div>
                  <div style={{ padding:"4px 10px", borderRadius:"20px", fontSize:"0.75rem", fontWeight:700, color:"#4b5563", background:"#1a1a1a", border:"1px solid #2a2a2a", whiteSpace:"nowrap" }}>
                    ✔️ Enviado
                  </div>
                </div>
              ))}
            </>
          )}

        </div>
      )}

      {/* Próximos 30 días */}
      {proximos30.length > 0 && (
        <div style={{ marginTop:"36px" }}>
          <div style={{ fontSize:"0.75rem", fontWeight:800, color:"#4b5563", textTransform:"uppercase", letterSpacing:"0.6px", marginBottom:"12px" }}>
            📅 Próximos 30 días
          </div>
          <div style={{ display:"flex", flexDirection:"column", gap:"8px" }}>
            {proximos30.map(({ c, dias }) => (
              <div key={c.id}>
                <FilaCumple c={c} disabled={dias > 0}/>
                {dias === 0 && (
                  <>
                    <textarea
                      readOnly
                      value={msgCumple(c.nombre)}
                      style={{ width:"100%", marginTop:"8px", padding:"10px", background:"#1a1a1a", border:"1px solid #2a2a2a", borderRadius:"8px", color:"#e5e7eb", fontSize:"0.8rem", resize:"none", fontFamily:"Inter, sans-serif", lineHeight:1.5, boxSizing:"border-box" }}
                      rows={3}
                    />
                    <button
                      onClick={() => navigator.clipboard.writeText(msgCumple(c.nombre))}
                      style={{ marginTop:"6px", padding:"6px 14px", background:"#25d36620", border:"1px solid #25d36660", borderRadius:"6px", color:"#25d366", fontFamily:"Inter, sans-serif", fontWeight:700, fontSize:"0.8rem", cursor:"pointer" }}
                    >
                      Copiar mensaje
                    </button>
                  </>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}
